import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRebuildCollectionClosureV1Response } from './rebuild-collection-closure-v1-response';
import { rebuildCollectionClosureV1ResponseSchema } from './rebuild-collection-closure-v1-response';

export async function rebuildCollectionClosureV1Api(): Promise<
  IValidatedResponse<IRebuildCollectionClosureV1Response>
> {
  return postRequest<IRebuildCollectionClosureV1Response>({
    path: '/sys/collections/v1/rebuild-closure',
    schema: rebuildCollectionClosureV1ResponseSchema,
  });
}
